"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('../../../ui/js/api-header-injector.js');
require('../../../ui/js/language.js');
require("./menu/menu");
var api_1 = require("./api/api");
var user_1 = require("./user/user");
var auth_1 = require("./auth/auth");
var login_modal_helper_1 = require("./helpers/login-modal-helper");
var credit_1 = require("./credit/credit");
var cookie_helper_1 = require("./helpers/cookie-helper");
var navbar_display_1 = require("./navbar/navbar-display");
require('../scss/' + CSS_THEME + '.scss');
window['$'] = require('jquery');
require('bootstrap');
window['lang'] = getUrlParameter('lang');
window['language'] = window['lang'] === null ? 'en' : window['lang'];
window['token'] = getUrlParameter('token');
function getUrlParameter(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}
window.redirectToUrl = function (game, terminal) {
    if (terminal === void 0) { terminal = false; }
    window['token'] = getUrlParameter('token');
    window['lang'] = getUrlParameter('lang') !== null ? getUrlParameter('lang') : 'en';
    if (!terminal) {
        if (getUrlParameter('backUrl')) {
            window.location.href = game + '/index.html?token=' + window['token'] + '&lang=' + window['lang'] + '&backUrl=' + getUrlParameter('backUrl');
        }
        else {
            window.location.href = game + '/index.html?token=' + window['token'] + '&lang=' + window['lang'];
        }
    }
    else {
        window.location.href = game + '/terminal.html?token=' + window['token'] + '&lang=' + window['lang'];
    }
};
function loginManagement(auth, user, navbar, credit) {
    if (user.isLogggedIn()) {
        window['token'] = cookie_helper_1.default.get('token');
        var response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: cookie_helper_1.default.get('currency')
                    }
                ]
            }
        };
        navbar.showLogedIn(user, response);
    }
    else {
        navbar.showLogedOut();
    }
    $('#nav-icon1').click(function (e) {
        e.preventDefault();
        $('#wrapper').toggleClass('active');
        $(this).toggleClass('open');
    });
    $('.logout-button').click(function () {
        var logoutEvent = new CustomEvent('logout');
        window.dispatchEvent(logoutEvent);
    });
    $('.login-button').click(function () {
        $('.login-modal').modal('show');
    });
    $('.login-user-button').click(function () {
        auth.login(login_modal_helper_1.default.bind(user));
    });
    $('.user-username').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.user-password').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
}
var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];
if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
    window['API_URL'] = SPECIAL_API_URL;
    console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
}
else {
    window['API_URL'] = API_URL;
}
$(document).ready(function () {
    var api = new api_1.default(window['API_URL'] + '/video-roulette');
    var user = new user_1.default();
    var auth = new auth_1.default(api);
    var credit = new credit_1.default(api);
    var navbar = new navbar_display_1.default();
    getDefaults();
    loginManagement(auth, user, navbar, credit);
    getUrlParameter('backUrl') ? $('.go-back-btn').css('display', 'flex') :
        $('.go-back-btn').css('display', 'none');
    $('.go-back-btn').click(function (e) {
        e.preventDefault();
        window.location.replace(getUrlParameter('backUrl'));
    });
});
function showNavbar() {
    if (window['showLogin'] === 1) {
        $('.game-nav-bar').css('display', 'flex');
    }
    else {
        $('.game-nav-bar').css('display', 'none');
    }
}
function getDefaults() {
    $.ajax({
        url: window['API_URL'] + '/video-roulette/game-config/get',
        type: 'post',
        data: {},
        success: function (response) {
            window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] !== '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
            if (window['menu']) {
                $('#nav-icon1').show();
                window['renderMenu']();
            }
            window['currency'] = response.Currency;
            window['showLogin'] = (response['showLogin'] !== undefined && response['showLogin'] !== '' && response['showLogin'] != null) ? response['showLogin'] : 0;
            $('#currency').text(window['currency']);
            showNavbar();
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.warn('jqXHR:' + jqXHR + ' text:' + textStatus);
            console.warn(errorThrown);
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/ts/main.ts
// module id = 2423
// module chunks = 10